import React from 'react'
import T from 'prop-types'
import VisibilitySensor from 'react-visibility-sensor'
import { styled } from '@mui/material/styles'
import { Box, Paper, Stack, Typography } from '@mui/material'
import theme from 'theme'

import CarSpecifications from '../organisms/SessionsConfirmation/CarSpecifications'

const classes = {
  itemGrid: 'item-grid',
  carImage: 'car-image',
  carContent: 'car-content',
  carTitle: 'car-title',
  carSubtitle: 'car-subtitle',
  carPrice: 'car-price',
}
const Root = styled(Paper)(({ theme, height }) => ({
  height: `${height}px`, // The fixed height is required to stabilize the VisibilitySensor
  marginBottom: theme.spacing(1.5),
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  [`& .${classes.itemGrid}`]: {
    display: 'grid',
    gridTemplateColumns: '3fr 9fr 1.5fr',
    columnGap: theme.spacing(2),
    [`& .${classes.carImage}`]: {
      display: 'block',
      maxWidth: '100%',
      maxHeight: theme.custom.carCardMaxHeight,
      borderRadius: theme.shape.borderRadius,
    },
  },
  [`& .${classes.carContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [`& .${classes.carTitle}`]: {
      paddingBottom: theme.spacing(0.5),
    },
    [`& .${classes.carSubtitle}, & .${classes.carPrice}`]: {
      paddingBottom: theme.spacing(1),
    },
  },
}))

function CarCard({
  onClick,
  car,
  price,
  fee,
  inventoryPrice,
  inventoryFee,
  isAssignment,
  maxPrice,
  height = theme.custom.carCardMaxHeight,
  priceLabel,
  hideTotalPrice,
  right,
  bottom,
  rightProps,
  bottomProps,
  ...others
}) {
  const numberFormatter = new Intl.NumberFormat('it-IT')

  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => {
        return isVisible ? (
          <Root height={height} {...others}>
            <Box className={classes.itemGrid}>
              <Box onClick={onClick} sx={{ cursor: 'pointer' }}>
                <Box
                  component="img"
                  src={car.pictureurl}
                  className={classes.carImage}
                  alt={car.title}
                  sx={{ maxHeight: height, width: 'auto' }}
                />
              </Box>
              <Box
                onClick={onClick}
                className={classes.carContent}
                sx={{ cursor: 'pointer' }}
                data-testid="car-detail-click"
              >
                <div>
                  <Typography
                    variant="body1"
                    color="textPrimary"
                    className={classes.carTitle}
                  >
                    <strong>
                      {car.brand} {car.model}
                    </strong>
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    className={classes.carSubtitle}
                  >
                    {car.title}
                  </Typography>
                </div>
                <Typography
                  variant="body2"
                  color="primary"
                  className={classes.carPrice}
                >
                  <strong>
                    {!hideTotalPrice &&
                      price &&
                      fee &&
                      ` € ${numberFormatter.format(fee + price)}`}

                    {hideTotalPrice &&
                      inventoryPrice &&
                      inventoryFee &&
                      ` € ${numberFormatter.format(
                        inventoryPrice + inventoryFee
                      )}`}
                  </strong>
                </Typography>
                <CarSpecifications
                  car={car}
                  isAssignment
                  price={inventoryPrice || price}
                  fee={inventoryFee || fee}
                />
              </Box>
              <Stack
                justifyContent="space-between"
                alignItems="flex-end"
                {...rightProps}
              >
                {right}
              </Stack>
            </Box>
            <Box {...bottomProps}>{bottom}</Box>
          </Root>
        ) : (
          <Root height={height} {...others} />
        )
      }}
    </VisibilitySensor>
  )
}

CarCard.propTypes = {
  linkTo: T.string,
  car: T.object.isRequired,
  price: T.number,
  fee: T.number,
  maxPrice: T.number,
  right: T.node,
  rightProps: T.object,
  bottom: T.node,
  bottomProps: T.object,
  priceLabel: T.string,
  hideTotalPrice: T.bool,
  isAssignment: T.bool,
}

export default CarCard
